import { campaigns } from "./api";

export default async function fetchCampaignData({
  accessToken,
  countryCode,
  mainCountryId,
}) {
  const urlParams = new URLSearchParams();
  // if (countryCode) urlParams.append("siteId", countryCode);
  if (mainCountryId) urlParams.append("countryId", mainCountryId);

  const res = await campaigns.get(
    `/GetProductAdsMetricsByCountry?${urlParams.toString()}`,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        accept: "*/*",
      },
    },
  );
  const data = res.data || [];
  console.log("Campaigns data", data);

  return data;
}
